/*
 * CarSelectConstants
 */

export const GET_BRANDS = 'ideal/CarSelector/GET_BRANDS';
export const BRANDS_RECEIVED = 'ideal/CarSelector/BRANDS_RECEIVED';
export const BRANDS_ERROR = 'ideal/CarSelector/BRANDS_ERROR';
export const BRAND_SELECTED = 'ideal/CarSelector/BRAND_SELECTED';

export const MODELS_RECEIVED = 'ideal/CarSelector/MODELS_RECEIVED';
export const MODELS_ERROR = 'ideal/CarSelector/MODELS_ERROR';
export const MODEL_SELECTED = 'ideal/CarSelector/MODEL_SELECTED';

export const VERSIONS_RECEIVED = 'ideal/CarSelector/VERSIONS_RECEIVED';
export const VERSIONS_ERROR = 'ideal/CarSelector/VERSIONS_ERROR';
export const VERSION_SELECTED = 'ideal/CarSelector/VERSION_SELECTED';

export const CAR_RECEIVED = 'ideal/CarSelector/CAR_RECEIVED';
export const CAR_ERROR = 'ideal/CarSelector/CAR_ERROR';

export const GET_CAR_IMAGES = 'ideal/CarSelector/GET_CAR_IMAGES';
export const CAR_IMAGES_RECEIVED = 'ideal/CarSelector/CAR_IMAGES_RECEIVED';
export const CAR_IMAGES_ERROR = 'ideal/CarSelector/CAR_IMAGES_ERROR';
export const CAR_IMAGES_NEW = 'ideal/CarSelector/CAR_IMAGES_NEW';

export const RESET = 'ideal/CarSelector/RESET';

